import { IFieldAccessType } from '../../../../../component/admin-module/module/users/interface/field';
import ValidateField from '../../../validation';
import { IValidationError } from '../../../validation/type/validation-type';
import { FieldElement } from '../../field-element';
import { TValidationType, PropType } from '../field-properties.handler';

interface IGeoLocationProps {
  value: { lon: number, lat: number, label?: string };
  error?: IValidationError[];
  fieldType?: 'geolocation';
}

export class GeoLocationProps extends PropType<IGeoLocationProps, IGeoLocationProps> {

  processValueFromRef(data: IGeoLocationProps): IGeoLocationProps {
    data.value = data.value || { lon: 0, lat: 0 };
    return data;
  }

  processValueToRef(newData: IGeoLocationProps): IGeoLocationProps {
    newData.value = newData.value || { lon: 0, lat: 0 };
    return newData;
  }

  processValidation(props: IGeoLocationProps | IGeoLocationProps, field: FieldElement, validationType: TValidationType): IValidationError[] {
    const value = props.value || { lon: 0, lat: 0 };
    const validateField = new ValidateField();
    const validate = validateField.singleField(field, value, validationType);
    return field.accessType === IFieldAccessType.Required || !!value ? validate : [];
  }
}